module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "memo"
  }, [_c('h1', [_vm._v("音声入力メモ")]), _vm._v(" "), _c('voice-input', {
    attrs: {
      "voiceInput": _vm.voiceInput
    },
    on: {
      "update:voiceInput": function($event) {
        _vm.voiceInput = $event
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v("「" + _vm._s(_vm.voiceInput.message) + "」")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010aebfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Memo.vue
// module id = 476
// module chunks = 1